import { render, staticRenderFns } from "./TambahKeluarga.vue?vue&type=template&id=3a0cc22a&scoped=true"
import script from "./TambahKeluarga.vue?vue&type=script&lang=js"
export * from "./TambahKeluarga.vue?vue&type=script&lang=js"
import style0 from "./TambahKeluarga.vue?vue&type=style&index=0&id=3a0cc22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0cc22a",
  null
  
)

export default component.exports